<template>
  <div class="app-container">
    <list ref="list">
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
              v-if="$permission.canEdit() && row.ResultStatus !=2  "
              icon="el-icon-edit"
              title="编辑"
              type="text" size="medium"
              @click.stop="edit(row)"
            ></el-button>
    
            <el-button v-if="$permission.canRead() || $permission.canReview()" type="text" size="medium" @click.stop="details(row)" icon="el-icon-document" title="详情"></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <details-dialog ref="detailDialog" @close-saved="reload"></details-dialog>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>

<script>
import list from "@/components/consult/complaint/list";
import detailsDialog from "@/components/consult/complaint/detailsDialog";
import editDialog from "@/components/consult/complaint/editDialog";
import curdMixin from "@/mixins/curd";
export default {
  name: "complaint",
  mixins: [curdMixin],
  components: {
    list,
    editDialog,
    detailsDialog,
  },
  reload(){
    this.$refs.list.reload();
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  methods: {
    //详情
    details(row) {
      this.$refs.detailDialog.openDetailsById(row.ComplainId);
    },
    //编辑
    edit(row) {
      this.$refs.editDialog.openEditById(row.ComplainId);
    },
    //删除
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RefundId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
</style>